import React from "react";
import { Sorting } from "@elastic/react-search-ui";
import { resultFieldCells } from "../../../config/faq-config-helper";
import { useTranslation } from "react-i18next";

const SortButton = ({ fieldName }) => {
  return (
    <Sorting
      label={fieldName}
      sortOptions={[
        {
          // A display name, like "Name"
          name: "relevence",
          // A field name, like "name".
          value: fieldName,
          // asc or desc
          direction: "",
        },
        {
          // A display name, like "Name"
          name: "shape asc",
          // A field name, like "name".
          value: fieldName,
          // asc or desc
          direction: "asc",
        },
        {
          // A display name, like "Name"
          name: "shape desc",
          // A field name, like "name".
          value: fieldName,
          // asc or desc
          direction: "desc",
        },
      ]}
      view={({ className, label, onChange, options, value, ...rest }) => {
        const isSorted = value.includes(label) && value !== `${label}|||`;
        const isAsc = value.includes("asc");
        return (
          <button
            onClick={() => {
              isSorted
                ? isAsc
                  ? onChange(options[0].value)
                  : onChange(options[1].value)
                : onChange(options[2].value);
            }}
          >
            {/* {isSorted ? (isAsc ? "ASC" : "DESC") : "Not Sorted"} */}
          </button>
        );
      }}
    />
  );
};
function TableHeader() {
  const { t } = useTranslation();
  return (
    <thead>
      <tr className="u-font--s">
        {resultFieldCells
          .filter(({ hidden }) => !hidden)
          .map((cell, index) => {
            return (
              <th
                width={cell.width}
                className={
                  cell.isSortable
                    ? "control parametric-search-th"
                    : "parametric-search-th"
                }
                key={index}
              >
                {/* cell.label is hardcoded, so there is no risk of untrusted input being injected. */}
                <span
                  dangerouslySetInnerHTML={{ __html: t(cell.label) }}
                ></span>
                {cell.isSortable && <SortButton fieldName={cell.field} />}
              </th>
            );
          })}
      </tr>
    </thead>
  );
}
export default TableHeader;
